module.exports = __webpack_public_path__ + "static/media/txt-icon.d8791a51.svg";